module.exports = __webpack_public_path__ + "02_short_brown.32680320.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/02_short_brown.png
// module id = NcEo
// module chunks = 0